import { jsx as _jsx } from "react/jsx-runtime";
import { unpack_validation } from 'z3k-parser/validation/types';
import { Z3kDragDropContainer } from '../utils/drag-drop-drawer/container';
import { RouteNaming, Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { DragDropDrawer } from '../utils/drag-drop-drawer/component';
export function WebElementsList() {
    const childrenItem = (selected_item_id) => {
        return (_jsx(DragDropDrawer, { z3k_name: "web_elements", name: RouteNaming[Z3kSecondRoutes.web_elements], item_url: Z3kSecondRoutes.web_elements, help_id: "web_elements", enableDnd: true, selected_item_id: selected_item_id }));
    };
    return _jsx(Z3kDragDropContainer, { childrenItem: childrenItem });
}
WebElementsList.isError = (validation_result) => !!unpack_validation(validation_result, 'web_elements');
WebElementsList.isWarning = WebElementsList.isError;
WebElementsList.isShown = (is_service_view, config, device_spec, is_staff, is_climatic) => !is_climatic &&
    device_spec.show_settings.show_WebElementsPage &&
    device_spec.io.has_web_elements &&
    is_service_view;
